import { Box, Stack } from '@mui/system';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, ButtonGroup, TextField, Typography } from '@mui/material';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import AddIcon from '@mui/icons-material/Add';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Link } from 'react-router-dom';
import GlobalDatagrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import { useSelector } from 'react-redux';
import { RegularizationGetThunk, RegularizeDeleteThunk } from '../../../redux/features/leaveSlice';
import { useDispatch } from 'react-redux';
import GetColumns from './Regularize/GetColumns';
import ApproveOrRjectRegularization from './Regularize/ApproveOrReject';
import dayjs from 'dayjs';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';

export default function AttendanceRegularization({ head }) {
  const { data: regularizeGet, meta } = useSelector((state) => state.leave.regularize);
  const { loading } = useSelector((state) => state.leave);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search, checkedRowsIds } = paginationData;
  const [actionDependancy, setActionDependancy] = useState(false);
  const [searchFromDate, setSearchFromDate] = useState('');
  const [searchToDate, setSearchToDate] = useState('');
  const [open, setOpen] = useState(false);
  const handleApiResponse = useHandleApiResponse();

  const generateSelectedData = () => regularizeGet?.filter((e) => checkedRowsIds?.includes(e.id));

  const DeleteHandler = (id) => {
    dispatch(RegularizeDeleteThunk(id)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
          setActionDependancy((prev) => !prev);
        },
      });
    });
  };

  const dispatch = useDispatch();
  useEffect(() => {
    let view = '';
    if (head === 'HR') view = 'hr';
    else if (head === 'Team Head') view = 'rh';
    dispatch(
      RegularizationGetThunk({
        view,
        limit: gridSize,
        page: pageNum,
        search,
        fromDate: searchFromDate,
        toDate: searchToDate,
      })
    );
  }, [gridSize, pageNum, search, actionDependancy, searchFromDate, searchToDate]);

  const columns = useMemo(() => GetColumns(head, setOpen), [head]);

  return (
    <GlobalWrapper title={head ? `Attendance Regularization ${head}` : 'Attendance Regularization Requests'}>
      <Stack sx={{ width: '100%' }} gap={2}>
        <Box display={'flex'} justifyContent="space-between">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box display={'flex'} gap={1} flexDirection={{ xs: 'column', sm: 'row' }}>
              <DatePicker
                label="From Date"
                format="DD-MM-YYYY"
                renderInput={(params) => <TextField {...params} />}
                onChange={(e) => {
                  setSearchFromDate(e ? dayjs(e).format('YYYY-MM-DD') : '');
                }}
              />
              <DatePicker
                label="To Date"
                format="DD-MM-YYYY"
                renderInput={(params) => <TextField {...params} />}
                onChange={(e) => {
                  setSearchToDate(e ? dayjs(e).format('YYYY-MM-DD') : '');
                }}
              />
            </Box>
          </LocalizationProvider>
          {head ? (
            <ButtonGroup disabled={!checkedRowsIds?.length}>
              <ApproveOrRjectRegularization
                data={generateSelectedData()}
                setActionDependancy={setActionDependancy}
                view={head}
              />
              <ApproveOrRjectRegularization
                reject={true}
                data={generateSelectedData()}
                setActionDependancy={setActionDependancy}
                view={head}
                paginationData={paginationData}
              />
            </ButtonGroup>
          ) : (
            <Link to={'request'} style={{ alignSelf: 'flex-start' }}>
              <Button startIcon={<AddIcon />} variant="contained" color="secondary">
                Add Request
              </Button>
            </Link>
          )}
        </Box>

        <GlobalDatagrid
          tableHead={columns}
          rows={regularizeGet || []}
          meta={meta?.totalRecords || 0}
          rowUniqueId="id"
          loading={loading}
          checkboxSelection={Boolean(head)}
        />
        <GlobalDialog
          open={Boolean(open)}
          setOpen={setOpen}
          title={'Are you Sure to Delete ? '}
          content={
            <Box display={'flex'} flexDirection="column" gap={1}>
              <Box>
                <Typography>{`${open?.slNo} : ${open?.createdByName}`}</Typography>
              </Box>
              <Box alignSelf={'flex-end'} display="flex" gap={1}>
                <Button variant="contained" color="error" onClick={() => setOpen(false)}>
                  cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={() => {
                    DeleteHandler(open?.id);
                  }}
                >
                  {loading ? 'Please Wait...' : 'sure'}
                </Button>
              </Box>
            </Box>
          }
        />
      </Stack>
    </GlobalWrapper>
  );
}
